import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RestaurantAutocomplete } from "src/components/Main/MainLayout/RestaurantAutocomplete";

export default function SideBarRestaurantSelect({ restaurants }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 2, py: 2 }}>
      <RestaurantAutocomplete
        restaurants={restaurants}
        placeholder={t("sideBar.selectRestaurant")}
      />
    </Box>
  );
}
